import { createAsyncThunk } from '@reduxjs/toolkit'

import { fetchTranslations } from '@app/api'
import { getUserLanguage } from '@app/utils'

export const getTranslationsThunk = createAsyncThunk(
  'translation',
  async () => {
    const userLanguage = getUserLanguage()

    return await fetchTranslations(userLanguage)
  }
)
